import React, { useEffect, useState } from "react";
import { editSettings, getAllSettings } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "components/shared/Loader";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SiteInfo from "./SiteInfo";
import SocialTypesSettings from "./SocialTypesSettings";

const Settings = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();

  const { error } = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      toast.error(<FormattedMessage id={"sendingErrorMessage"} />, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  return (
    <div className="acc-form settings_tabs">
      {/* <Tabs
        defaultActiveKey="mainSettings"
        id="home_page_tabs"
        className="home_page_tabs__"
      >
        <Tab
          eventKey="mainSettings"
          title={formatMessage({ id: "mainSettings" })}
        > */}
      <SiteInfo />
      {/* </Tab> */}
      {/* <Tab
          eventKey="socialTypesSettings"
          title={formatMessage({ id: "socialTypesSettings" })}
        >
          <SocialTypesSettings />
        </Tab>
        <Tab
          eventKey="socialSettings"
          title={formatMessage({ id: "socialSettings" })}
        >
          <SocialTypesSettings />
        </Tab> */}
      {/* </Tabs> */}
    </div>
  );
};

export default Settings;
